export const AEROVISTA_CLUB_URL = "https://aerovistaclub.co.uk";
export const VISTACION_URL = "https://project-xhavn.vercel.app";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phoneDisplay: "07749 395963",
  phoneTel: "tel:+447749395963",
  whatsappDisplay: "07708 238952",
  whatsappUrl: "https://wa.me/447708238952",
  email: "marcelle@aerovistaclub.co.uk",
};

export const PARTNERS = [
  { name: "Mirai Flights", url: "https://miraiflights.com", role: "Charter sourcing" },
  { name: "Burgess Yachts", url: "https://www.burgessyachts.com", role: "Yacht brokerage" },
];

export const LEAD_TYPE_LABELS = {
  charter: "Charter",
  aircraft: "Aircraft",
  yacht: "Yacht",
  bullion: "Bullion",
  membership: "Membership",
  general: "General",
  vistacoin: "Vistacoin",
  jet_account: "Jet Account",
};

export const STATUS_LABELS = {
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  quoted: "Quoted",
  won: "Won",
  lost: "Lost",
};

export const TAG_LABELS = {
  buyer: "Buyer",
  seller: "Seller",
  charter_client: "Charter client",
  member: "Member",
  general: "General",
};

export const whatsappLink = (text) =>
  `${CONTACT.whatsappUrl}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
